import { JSXElement, mergeProps, splitProps } from 'solid-js';
import { twMerge } from 'tailwind-merge';
import { ark, HTMLArkProps } from '@ark-ui/solid';

type ThProps = HTMLArkProps<'th'>;

export default function Th(props: ThProps): JSXElement {
  const merged = mergeProps(
    {
      class: ''
    },
    props
  );
  const [split, rest] = splitProps(merged, ['class', 'children']);
  return (
    <ark.th
      class={twMerge(
        `px-3 py-3 first:px-6 first:py-3 text-left font-semibold`,
        split.class
      )}
      {...rest}
    >
      {split.children}
    </ark.th>
  );
}
